if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('disabled') === 'true') return;

      // リングサイズ（号数）の必須チェック＋範囲整合チェック
      const ringSizeSelect = this.getRequiredRingSizeSelect();
      if (ringSizeSelect) {
        const ringError = this.validateRingSize(ringSizeSelect);
        if (ringError) {
          this.handleErrorMessage(ringError);
          ringSizeSelect.focus();
          return;
        }
      }

      this.handleErrorMessage();
      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading--spinner')?.classList.remove('hidden');
      this.submitButton.querySelector('[data-add-to-cart-text]').classList.add('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.submitButton.setAttribute('disabled', true);
            this.error = true;
             const drawerSelector = document.querySelector("#quickView-drawer");
             setTimeout(() => {
              //focusElement = event.target;
              trapFocusElements(drawerSelector);
          }, 500);
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          if(this.cart){
            if(document.querySelector(".product-sticky-bar")){
              document.querySelector(".product-sticky-bar").classList.remove("is-visible")
            }
            this.cart.renderContents(response);
            this.cart.classList.add("is-visible");
            focusElement = this.submitButton;
            document.querySelector("body").classList.add("overflow-hidden");
          
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('[data-add-to-cart-text]').classList.remove('hidden');
          if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('disabled');
          this.querySelector('.loading--spinner')?.classList.add('hidden');
       
        });
    }

    // このフォームに紐付く必須リングサイズセレクトを返す（無ければ null）
    getRequiredRingSizeSelect() {
      const selects = document.querySelectorAll('[data-ring-size-select][required]');
      for (const select of selects) {
        if (select.form === this.form && select.offsetParent !== null) {
          return select;
        }
      }
      return null;
    }

    // 未選択、または選んだ号数が送信バリアントの範囲外なら
    // エラーメッセージ文字列を返す（問題なければ null）。
    // 二重セレクター等でバリアントと号数がズレた状態の追加を防ぐ保険。
    validateRingSize(ringSizeSelect) {
      if (!ringSizeSelect.value) return 'リングサイズ（号数）をお選びください。';

      const num = parseInt(ringSizeSelect.value, 10);
      if (Number.isNaN(num)) return null;

      const idInput = this.form.querySelector('[name="id"]');
      const info = this.closest('[data-product-info]');
      let jsonEl = info && info.querySelector('script[type="application/json"]');
      if (!jsonEl) jsonEl = document.querySelector('[data-product-info] script[type="application/json"]');
      if (!idInput || !jsonEl) return null;

      let variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return null; }
      const variant = variants.find((v) => String(v.id) === String(idInput.value));
      if (!variant || !variant.options) return null;

      // "N-M" 形式のサイズ範囲オプションを探す
      const rangeOption = variant.options.find((o) => /^\s*\d+\s*-\s*\d+\s*$/.test(o));
      if (!rangeOption) return null;

      const bounds = rangeOption.split('-').map((s) => parseInt(s, 10));
      if (num < bounds[0] || num > bounds[1]) {
        return 'リングサイズの選択が更新されていません。お手数ですがサイズを選び直してください。';
      }
      return null;
    }

    handleErrorMessage(errorMessage = false) {
     if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form--error-message-wrapper') || this.closest("product-card").querySelector('.product-form--error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form--error-message') || this.closest("product-card").querySelector('.product-form--error-message-wrapper');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}